import { useState } from 'react';
import "../styles/TeamsManagement.css"
import noGroupSelected from "../assets/images/noGroupSelected.svg"
import ErrorFetching from "../assets/images/ErrorFetching.svg"
import {
  LuMenu,
  LuCalendar,
  LuSearch,
  LuPlus,
  LuChevronDown,
  LuChevronRight
} from "react-icons/lu";

import { adjustTextColor, getInitials, getInitialsGroup, stringToColor } from '../functions/function';
import { ImSpinner9 } from 'react-icons/im';

const TeamsManagement = (props) => {
  const { setIsOpened, idTeamSelected, setIsPopup,
    teamMembers, isDisplayed, setIsDisplayed,
    currentTeamMembers, setCurrentTeamMembers,
    teamInfo, isLoading, isLoadingMemberList, isErrorFetching, isOwner,
    isLoadingMoreMember, fetchTeamMembers } = props;

  const [searchContent, setSearchContent] = useState("")

  const removeVietnameseTones = (str) =>
    str?.toLowerCase()?.normalize("NFD")?.replace(/[\u0300-\u036f]/g, "");

  const searchData = (content) => {
    const keywordNoTone = removeVietnameseTones(content);
    const keywordLower = content?.toLowerCase();

    const searchOwners = teamMembers.owners.filter((member) =>
      removeVietnameseTones(member.displayName)?.includes(keywordNoTone) ||
      member.mail?.toLowerCase().includes(keywordLower)
    );

    const searchMembers = teamMembers.members.filter((member) =>
      removeVietnameseTones(member.displayName)?.includes(keywordNoTone) ||
      member.mail?.toLowerCase().includes(keywordLower)
    );

    // Combine the filtered results from owners and members
    setCurrentTeamMembers({
      owners: searchOwners,
      members: searchMembers,
    });

    setIsDisplayed({
      owners: searchOwners?.length > 0,
      members: searchMembers?.length > 0,
    });
  };

  const getFormattedDate = (dateString) => {
    const date = new Date(dateString);

    // Extract the day, month, and year, but in UTC to avoid local time zone adjustments
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');  // Months are 0-indexed
    const year = date.getUTCFullYear();

    // Return in the format DD/MM/YYYY
    return `${day}/${month}/${year}`;
  }

  return (
    <div className="page-container">
      <button
        className="open-section"
        onClick={() => setIsOpened(true)}
      ><LuMenu /></button>
      {!idTeamSelected ? (
        <div className="inform-container">
          <img src={noGroupSelected} alt="error" />
          <p>Select a group to view its members.</p>
        </div>
      ) : isLoading ? (
        <div className="inform-container">
          <ImSpinner9 className="spin-icon" />
        </div>
      ) : isErrorFetching ? (
        <div className="inform-container">
          <img src={ErrorFetching} alt="error" />
          <p>We are experiencing some connection issues.</p>
          <p>Please refresh the page!</p>
        </div>
      ) : (
        <>
          <div className='group-info-container'>
            <div className='group-header' title='Group_ToLapTrinh'>
              {teamInfo.avatar ? (
                <img className="group-image" src={teamInfo.avatar} alt="Error" />
              ) : (
                <div
                  className="group-image"
                  style={{
                    backgroundColor: stringToColor(teamInfo.displayName),
                    color: "var(--white-color)"
                  }}
                >{getInitialsGroup(teamInfo.displayName)}</div>
              )}
              <p>{teamInfo.displayName}</p>
            </div>
            <p className='group-description'>
              {teamInfo.description}
            </p>
            <div className='group-detail'>
              <label><LuCalendar /> Creation date</label>
              <p>{getFormattedDate(teamInfo.createdDateTime)}</p>
            </div>
          </div>


          <div className="tool-section" style={{ zIndex: "0" }}>
            <p>All members</p>
            <div className='tool-box'>
              <div className="search-container" style={{ display: "none" }}>
                <LuSearch />
                <input
                  type="text"
                  placeholder="Search"
                  value={searchContent}
                  onChange={(e) => {
                    setSearchContent(e.target.value);
                    searchData(e.target.value);
                  }}
                />
              </div>

              <button
                className='create-button'
                onClick={setIsPopup}
                disabled={!isOwner}
                title={!isOwner ? "Only owners can add members" : ""}
                style={{ height: "35px" }}
              >
                <LuPlus />
                <span>Add member</span>
              </button>
            </div>
          </div>

          <div
            onScroll={(e) => {
              const div = e.currentTarget;
              if (div.scrollTop + div.clientHeight >= div.scrollHeight - 1 && !isLoadingMoreMember) {
                fetchTeamMembers();
              }
            }}
            className='member-list-container'>
            {isLoadingMemberList ? (
              <div className="loading-container">
                <ImSpinner9 className="spin-icon" />
              </div>
            ) : (
              <>
                <button
                  className='show-hide-list'
                  onClick={() => setIsDisplayed({ ...isDisplayed, owners: !isDisplayed.owners })}
                >
                  {isDisplayed.owners ? (<><LuChevronDown /></>) : (<><LuChevronRight /></>)}
                  <span>Owners ({currentTeamMembers.owners?.length})</span>
                </button>
                {currentTeamMembers.owners?.length > 0 && currentTeamMembers.owners.map((member, index) => (
                  <div
                    key={index}
                    className={`member-item ${isDisplayed.owners ? "active" : ""}`}
                    title={member.displayName} >
                    <div className='member-header'>
                      {member.avatar ? (
                        <img className='member-ava' src={member.avatar} alt="Error" />
                      ) : (
                        <div
                          className='member-ava'
                          style={{
                            backgroundColor: stringToColor(member.displayName),
                            color: adjustTextColor(stringToColor(member.displayName))
                          }}
                        >{getInitials(member.displayName)}</div>
                      )}

                      <div className='member-name'>
                        <p>{member.displayName}</p>
                        <p className='member-mail-1'>{member.mail}</p>
                      </div>
                    </div>
                    <div className='member-info'>
                      <p className='member-mail-2'>{member.mail}</p>
                    </div>
                  </div >
                ))}
                <button
                  className='show-hide-list'
                  onClick={() => setIsDisplayed({ ...isDisplayed, members: !isDisplayed.members })}
                >
                  {isDisplayed.members ? (<><LuChevronDown /></>) : (<><LuChevronRight /></>)}
                  <span>Members and guests ({teamInfo.membersQuantity - teamMembers.owners.length})</span>
                </button>
                {currentTeamMembers.members?.length > 0 && currentTeamMembers.members.map((member, index) => (
                  <div
                    key={index}
                    className={`member-item ${isDisplayed.members ? "active" : ""}`}
                    title={member.displayName} >
                    <div className='member-header'>
                      {member.avatar ? (
                        <img className='member-ava' src={member.avatar} alt="Error" />
                      ) : (
                        <div
                          className='member-ava'
                          style={{
                            backgroundColor: stringToColor(member.displayName),
                            color: adjustTextColor(stringToColor(member.displayName))
                          }}
                        >{getInitials(member.displayName)}</div>
                      )}

                      <div className='member-name'>
                        <p>{member.displayName}</p>
                        <p className='member-mail-1'>{member.mail}</p>
                      </div>
                    </div>
                    <div className='member-info'>
                      <p className='member-mail-2'>{member.mail}</p>
                    </div>
                  </div >
                ))}
                {isLoadingMoreMember && (
                  <div className="inform-container">
                    <ImSpinner9 className="spin-icon" style={{ fontSize: "1.5rem" }} />
                  </div>
                )}
              </>
            )}
          </div>
        </>
      )
      }
    </div >
  )
}

export default TeamsManagement;